import {AuthKitProvider} from '@workos-inc/authkit-react';
import {variables as authVariables} from '@/environment/auth';

function AuthProvider({children}: React.PropsWithChildren) {
  return (
    <AuthKitProvider
      clientId={authVariables.WORKOS_CLIENT_ID.value}
      redirectUri={authVariables.WORKOS_REDIRECT_URI.value}
    >
      {children}
    </AuthKitProvider>
  );
}

export {AuthProvider};
